import script from "./Global.vue?vue&type=script&setup=true&lang=js"
export * from "./Global.vue?vue&type=script&setup=true&lang=js"

import "./Global.vue?vue&type=style&index=0&id=6f72cbea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f72cbea"]])

export default __exports__